<template>
  <div class="lv-month-picker">
    <span class="lv-month-icon">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2"/>
        <path d="M16 2v4M8 2v4M3 10h18"/>
      </svg>
    </span>
    <vue-monthly-picker
      class="lv-month-control"
      :value="value"
      :selectedBackgroundColor="selectedBackgroundColor"
      :monthLabels="monthLabels"
      :dateFormat="dateFormat"
      :clearOption="clearOption"
      :placeHolder="placeholder"
      @input="onInput"
      @selected="onSelected"
    ></vue-monthly-picker>
  </div>
</template>

<script>
import VueMonthlyPicker from "vue-monthly-picker"

export default {
  name: "LvMonthPicker",
  props: {
    value: {
      default: null,
    },
    selectedBackgroundColor: {
      type: String,
      default: "#5b4fcf",
    },
    monthLabels: {
      type: Array,
      default() {
        return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      },
    },
    dateFormat: {
      type: String,
      default: "MMMM , YYYY",
    },
    clearOption: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "All Time",
    },
  },
  methods: {
    onInput(value) {
      this.$emit("input", value)
    },
    onSelected(value) {
      this.$emit("selected", value)
    },
  },
  components: {
    VueMonthlyPicker,
  },
}
</script>

<style>
.lv-month-control .date-popover .monthItem .item.active {
  background: #fff !important;
  color: #1a1a2e;
  text-shadow: none;
}

.lv-month-control .date-popover .monthItem .item.active:hover {
  background: #f0effe !important;
  color: #413b94;
}

.lv-month-control .date-popover .monthItem .item.selected {
  background: #5b4fcf !important;
  color: #fff;
}

.lv-month-control .date-popover .monthItem .item.deactive {
  background: #fafafa !important;
  color: #8a8a9a;
}
</style>

<style scoped>
.lv-month-picker {
  position: relative;
  width: 100%;
  min-width: 0;
}

.lv-month-icon {
  position: absolute;
  z-index: 2;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #5b4fcf;
  pointer-events: none;
}

.lv-month-picker /deep/ .lv-month-control {
  width: 100%;
}

.lv-month-picker /deep/ input {
  width: 100%;
  height: 36px;
  border: 1px solid #e8e8ed;
  border-radius: 8px;
  background: #fafafa;
  color: #1a1a2e;
  font-size: 13px;
  padding: 0 38px 0 12px;
  box-sizing: border-box;
}

.lv-month-picker /deep/ input:focus {
  border-color: #5b4fcf;
  outline: none;
  background: #fff;
}

.lv-month-picker /deep/ .month-picker-wrapper {
  position: relative;
}

.lv-month-picker /deep/ .date-popover {
  width: 100%;
  max-width: 360px;
  min-width: 320px;
  margin-top: 8px;
  border: 1px solid #e8e8ed;
  border-radius: 10px;
  box-shadow: 0 10px 28px rgba(26, 26, 46, 0.12);
  background: #fff;
  overflow: hidden;
  color: #1a1a2e;
  font-size: 13px;
  font-weight: 600;
  z-index: 20;
}

.lv-month-picker /deep/ .date-popover .picker {
  background: #fff;
}

.lv-month-picker /deep/ .date-popover .flexbox {
  display: flex;
  align-items: center;
  padding: 0;
  border-bottom: 1px solid #f0f0f5;
}

.lv-month-picker /deep/ .date-popover .flexbox:first-child {
  height: 44px;
  background: #fafafa;
}

.lv-month-picker /deep/ .date-popover .flexbox:first-child > div {
  color: #1a1a2e;
  font-size: 15px;
  font-weight: 700;
  padding: 0;
}

.lv-month-picker /deep/ .date-popover .monthItem {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-bottom: 0;
  padding: 8px;
  gap: 6px;
}

.lv-month-picker /deep/ .date-popover .monthItem .item {
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: #fff !important;
  color: #1a1a2e;
  font-size: 13px;
  font-weight: 600;
  text-shadow: none;
  transition: background 0.15s ease, color 0.15s ease;
}

.lv-month-picker /deep/ .date-popover .monthItem .item.active:hover {
  background: #f0effe !important;
  color: #413b94;
}

.lv-month-picker /deep/ .date-popover .monthItem .item.selected {
  background: #5b4fcf !important;
  color: #fff;
}

.lv-month-picker /deep/ .date-popover .monthItem .item.deactive {
  background: #fafafa !important;
  color: #8a8a9a;
}

.lv-month-picker /deep/ .date-popover .prev,
.lv-month-picker /deep/ .date-popover .next {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  position: relative;
  text-indent: -9999px;
}

.lv-month-picker /deep/ .date-popover .prev:after,
.lv-month-picker /deep/ .date-popover .next:after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 8px;
  height: 8px;
  border: 0;
  border-left: 2px solid #5b4fcf;
  border-bottom: 2px solid #5b4fcf;
}

.lv-month-picker /deep/ .date-popover .prev:after {
  transform: translate(-35%, -50%) rotate(45deg);
}

.lv-month-picker /deep/ .date-popover .next:after {
  transform: translate(-65%, -50%) rotate(-135deg);
}

.lv-month-picker /deep/ .date-popover .prev:hover,
.lv-month-picker /deep/ .date-popover .next:hover {
  background: #f0effe;
  cursor: pointer;
}

.lv-month-picker /deep/ .date-popover .prev.deactive:after,
.lv-month-picker /deep/ .date-popover .next.deactive:after {
  border-color: #8a8a9a;
}

.lv-month-picker /deep/ .vmp-input-append {
  right: 34px;
  width: 28px;
  color: #8a8a9a;
}

.lv-month-picker /deep/ .vmp-clear-icon {
  color: #8a8a9a;
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// LvMonthPicker.vue?3ff63ec9